import React from 'react';
import { identity } from "../utils/getIdentity";
import AddressBookWrapper from "../components/AddressBook/AddressBookWrapper";

const AddressBook = () => {
  return (
    <div className={`component component-${identity} block-width`}>
      <AddressBookWrapper />
    </div>
  )
};

export default AddressBook;